import { render, staticRenderFns } from "./CategorySlider.vue?vue&type=template&id=8a6e151c"
import script from "./CategorySlider.vue?vue&type=script&lang=js"
export * from "./CategorySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryItem: require('/var/www/qanoniah.com/components/Search/Category/CategoryItem.vue').default,CategoryWrapper: require('/var/www/qanoniah.com/components/Search/Category/CategoryWrapper.vue').default})
